module.exports = __webpack_public_path__ + "static/media/index.97a83896.less";